// @ts-nocheck
/* eslint-disable react/jsx-no-target-blank */
import { FC, useEffect, useMemo, useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  Input,
  useToast,
  VStack,
  Image,
  Center,
  CircularProgress,
  Text,
  Container,
} from "@chakra-ui/react";
import { Field, Form } from "react-final-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  CustomInput,
  DownloadFile,
  CustomCheckbox,
  CustomSelect,
} from "../../../customComponents/components";
import { useUserList } from "../../../home/hooks";
import { useVehicleList } from "../../../vehicle/hooks";
import { useGetTravel, useGetUserData, useTravelSet } from "../../hooks";
import { useGetUser } from "../../../editUser/hooks";
import { PageHead } from "../../../home/components/PageHead";
import { CardsBlock } from "../../../editUser/components/CardsBlock";
import { DonwloadComponent } from "../../../customComponents/components/CustomInput/CustomInput";
import moment from "moment";
import { getTripPrice } from "./getTripPrice";
import { useVehicleMarkList } from "../../../vehicleTariff/hooks";
import { getVehicleRequest } from "../../../vehicle/network";
import dayjs from "dayjs";

export const TravelSet: FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const user_id_get = urlParams.get("user_id");
  const [initialValues, setInitialValues] = useState(
    user_id_get ? { user_id: user_id_get } : null,
  );
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  const { vehicleMarkList, getVehicleMarkList } = useVehicleMarkList();

  const tariffs = useMemo(() => {
    if (vehicleMarkList) {
      return vehicleMarkList;
    }
    return [];
  }, [vehicleMarkList]);

  const [dateStart, setDateStart] = useState<null | string>(null);
  const [dateEnd, setDateEnd] = useState<null | string>(null);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const [vehicleData, setVehicleData] = useState(null);

  const dayDiff = useMemo(() => {
    if (dateStart && dateEnd) {
      const mStart = moment(dateStart);
      const mEnd = moment(dateEnd);
      const diff = mEnd.diff(mStart, "days");
      if (diff >= 0) {
        return diff + 1;
      }
      return 0;
    }
    return 0;
  }, [dateStart, dateEnd]);

  useEffect(() => {
    if (selectedVehicleId) {
      getVehicleMarkList(selectedVehicleId);
    }
    getVehicleRequest(selectedVehicleId).then((res) => {
      console.log("getVehicleRequest data", res);
      //@ts-ignore
      window?.form?.change("insurance_payed", res?.data?.insurance_deposit);
    });
  }, [selectedVehicleId]);

  const rentPrice = useMemo(() => {
    return getTripPrice(tariffs || [], dayDiff);
  }, [tariffs, dayDiff]);

  useEffect(() => {
    //@ts-ignore
    console.log("window.form", window.form);
    //@ts-ignore
    window?.form?.change("price", rentPrice);
  }, [rentPrice]);

  console.log("dayDiff", dayDiff);
  console.log("vehicleMarkList", vehicleMarkList);
  console.log("selectedVehicleId", selectedVehicleId);
  console.log("rentPrice", rentPrice);

  const navigate = useNavigate();
  const { id } = useParams();
  const toast = useToast();

  const { userList } = useUserList();
  const { vehiclesList } = useVehicleList();
  const { travelSetReq } = useTravelSet();
  const { getTravel } = useGetTravel();

  const { getUserData, getUser } = useGetUserData();

  useEffect(() => {
    if (id) {
      getTravel(id).then((res) => {
        console.log("res is", res);
        setInitialValues(res.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (initialValues) {
      Promise.all([
        getUser(initialValues?.user_id),
        getUserData(initialValues?.user_id),
      ]).then(([res1, res2]) => {
        const { phone } = res1;
        const { surname, name, birth_date, driver_experience, user_id } = res2;
        setUserData({
          surname,
          name,
          birth_date,
          driver_experience,
          user_id,
          phone,
        });
      });
    }
  }, [initialValues]);

  const onSubmit = (values) => {
    if (id) {
      values.id = id;
    }
    const fd = new FormData();
    for (let value in values) {
      if (values[value] && ["agreement_link"].includes(value)) {
        fd.append(value, values[value][0]);
      } else {
        fd.append(value, values[value]);
      }
    }
    travelSetReq(fd).then((res) => {
      if (!id) {
        navigate(`/travel_set/${res.data.data.id}`);
      }
      toast({
        title: "Успешно",
        description: "Данные сохранены",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    });
  };

  if (loading) {
    return (
      <Box boxShadow="lg" p="6" rounded="md" bg="white">
        <Center>
          <CircularProgress isIndeterminate />
        </Center>
      </Box>
    );
  }

  return (
    <Form
      mutators={{
        setValue: ([field, value], state, { changeValue }) => {
          changeValue(state, field, () => value);
        },
      }}
      onSubmit={onSubmit}
      // validate={() => true}
      initialValues={{
        ...initialValues,
        //@ts-ignore
        other: initialValues?.other === "null" ? "" : initialValues?.other,
        price_payed:
          //@ts-ignore
          initialValues?.price_payed === "null"
            ? ""
            : //@ts-ignore
              initialValues?.price_payed,
      }}
      render={({ form, handleSubmit, values }) => {
        console.log("values?.agreement_link", values?.agreement_link);
        //@ts-ignore
        window.form = form;
        return (
          <Box boxShadow="lg" p="6" rounded="md" bg="white">
            <Flex justify="space-between">
              <Breadcrumb
                spacing="8px"
                separator={<ChevronRightIcon color="gray.500" />}
              >
                <BreadcrumbItem>
                  <BreadcrumbLink as={Link} to="/travel">
                    Поeздки
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink href="#">
                    {id ? id : "Новая поeздка"}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Flex>
            <Divider marginTop={"20px"} marginBottom={"20px"} />
            <Container maxWidth="1160px">
              <Flex>
                <div>
                  <Box minWidth="350" marginRight={30}>
                    <CardsBlock title="Данные клиента">
                      {userData && (
                        <>
                          <Flex>
                            <Text fontWeight="bold">Имя:&nbsp;</Text>
                            <Text>{userData.name}</Text>
                          </Flex>
                          <div style={{ height: 10 }} />
                          <Flex>
                            <Text fontWeight="bold">Телефон:&nbsp;</Text>
                            <Text>{userData.phone}</Text>
                          </Flex>
                          <div style={{ height: 10 }} />
                          <Flex>
                            <Text fontWeight="bold">Дата рождения:&nbsp;</Text>
                            <Text>{userData.birth_date}</Text>
                          </Flex>
                          <div style={{ height: 10 }} />
                          <Flex>
                            <Text fontWeight="bold">Стаж вождения:&nbsp;</Text>
                            <Text>{userData.driver_experience}</Text>
                          </Flex>
                          <div style={{ height: 10 }} />
                          <Text fontSize="sm" color="#A6A8AE">
                            уникальный ID пользователя: {userData?.user_id}
                          </Text>
                          <div style={{ height: 10 }} />
                          <Box>
                            <Button
                              as={Link}
                              to={`/edit_user/${userData?.user_id}`}
                            >
                              Открыть
                            </Button>
                          </Box>
                        </>
                      )}
                    </CardsBlock>
                  </Box>
                  <div style={{ height: 30 }} />
                  <Box minWidth="350" marginRight={30}>
                    <CardsBlock title="Общая стоимость">
                      <>
                        <Text fontSize={24}>
                          {(() => {
                            let res = 0;
                            if (values.price) {
                              res = res + Number(values.price);
                            }
                            if (values.other && values.other !== "null") {
                              res = res + Number(values.other);
                            }
                            return res;
                          })()}
                        </Text>
                        <div style={{ height: 30 }} />
                        <hr />
                        <div style={{ height: 30 }} />
                        {/* <Flex>
                          <Text fontWeight="bold">Предоплата:&nbsp;</Text>
                          <Text>оплачено 10 000</Text>
                        </Flex>
                        <div style={{ height: 10 }} /> */}
                        {/* <Flex>
                          <Text fontWeight="bold">Способ оплаты:&nbsp;</Text>
                          <Text>онлайн оплата</Text>
                        </Flex>
                        <div style={{ height: 10 }} /> */}
                        <Flex>
                          <Text fontWeight="bold">Будет начислено:&nbsp;</Text>
                          <Text>{Number(values.price || 0) * 0.01} баллов</Text>
                        </Flex>
                        <div style={{ height: 30 }} />
                        <hr />
                        <div style={{ height: 30 }} />
                        <Field
                          name={"price"}
                          component={CustomInput}
                          placeholder={"Стоимость аренды"}
                          label={"Стоимость аренды"}
                        />
                        <div style={{ height: 10 }} />
                        <Field
                          name={"insurance_payed"}
                          component={CustomInput}
                          placeholder={"Страховой взнос"}
                          label={"Страховой взнос"}
                        />
                        <div style={{ height: 10 }} />
                        <Field
                          name={"other"}
                          component={CustomInput}
                          placeholder={"Дополнительная сумма"}
                          label={"Дополнительная сумма"}
                        />
                        <div style={{ height: 10 }} />
                        <Field
                          name={"price_payed"}
                          component={CustomInput}
                          placeholder={"Оплачено клиентом за поездку"}
                          label={"Оплачено клиентом за поездку"}
                        />
                      </>
                    </CardsBlock>
                  </Box>
                </div>
                <Box width="100%">
                  <Heading size={"md"}>
                    {id ? "Редактировать поездку" : "Создать поездку"}
                  </Heading>
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    <Field
                      name={"date_start"}
                      placeholder={"Начало поездки"}
                      label={"Начало поездки"}
                      type="date"
                      component={(props) => (
                        <CustomInput {...props} onChangeDate={setDateStart} />
                      )}
                    />
                    <Field
                      name="date_end"
                      placeholder={"Конец поездки"}
                      label={"Конец поездки"}
                      // pattern={pattern}
                      component={(props) => (
                        <CustomInput {...props} onChangeDate={setDateEnd} />
                      )}
                      // component={CustomInput}
                      type={"date"}
                    />
                  </SimpleGrid>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    <Field
                      name={"user_id"}
                      component={CustomSelect}
                      options={userList}
                      placeholder={"Клиент"}
                      label={"Клиент"}
                    />
                    <Field
                      name={"vehicle_id"}
                      setSelectedVehicleId
                      component={(props) => (
                        <CustomSelect
                          {...props}
                          onChangeVehicleId={setSelectedVehicleId}
                        />
                      )}
                      // component={CustomSelect}
                      options={vehiclesList}
                      placeholder={"Автомобиль"}
                      label={"Автомобиль"}
                    />
                  </SimpleGrid>
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    {/* <Field
                      name={"deposit_payed"}
                      component={CustomInput}
                      placeholder={"Внесенный депозит"}
                      label={"Внесенный депозит"}
                    /> */}
                  </SimpleGrid>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <Flex width="100%">
                    <Box width="50%">
                      <Field
                        name={"baby_chair"}
                        component={CustomCheckbox}
                        inline
                        placeholder={"Нужно детское кресло"}
                        label={"Нужно детское кресло"}
                      />
                      <Field
                        name={"vehicle_delivery"}
                        component={CustomCheckbox}
                        inline
                        placeholder={"Нужна доставка автомобиля"}
                        label={"Нужна доставка автомобиля"}
                      />
                      <Field
                        name={"additional_mileage"}
                        component={CustomCheckbox}
                        inline
                        placeholder={"Нужен дополнительный пробег"}
                        label={"Нужен дополнительный пробег"}
                      />
                      <Field
                        name={"abroad"}
                        component={CustomCheckbox}
                        inline
                        placeholder={"Нужен выезд за пределы МО"}
                        label={"Нужен выезд за пределы МО"}
                      />
                      <Field
                        name={"additional_drivers"}
                        component={CustomCheckbox}
                        inline
                        placeholder={"Нужно несколько водителей для авто"}
                        label={"Нужно несколько водителей для авто"}
                      />
                    </Box>
                    <Box width="50%">
                      <Field
                        name={"status"}
                        component={CustomSelect}
                        options={[
                          {
                            id: "CREATED",
                            label: "Новая",
                          },
                          {
                            id: "CONFIRMED",
                            label: "Подтверждена (ждет начала)",
                          },
                          {
                            id: "INPROGRESS",
                            label: "В ходе выполнения",
                          },
                          {
                            id: "COMPLETED",
                            label: "Завершена",
                          },
                          {
                            id: "CANCELED",
                            label: "Отменена",
                          },
                          {
                            id: "DELETED",
                            label:
                              "Удалена (не будет отображаться у пользователя)",
                          },
                        ]}
                        placeholder={"Статус"}
                        label={"Статус"}
                      />
                      {values.status === "COMPLETED" && (
                        <Box
                          backgroundColor={"#E53E3E"}
                          borderRadius={16}
                          padding={"16px"}
                          marginTop={"20px"}
                        >
                          <Text color="#fff" fontSize="13px">
                            Пожалуйста, после завершения аренды, не забудьте
                            изменить баланс депозита у пользователя, если есть
                            такая необходимость
                          </Text>
                          <Link to={`/edit_user/${userData?.user_id}`}>
                            <Text
                              color="#fff"
                              fontSize="13px"
                              textDecoration={"underline"}
                            >
                              Перейти к пользователю
                            </Text>
                          </Link>
                        </Box>
                      )}
                      <div style={{ height: 20 }} />
                      <Field
                        name={"mileage"}
                        component={CustomInput}
                        placeholder={"Включен пробег (км)"}
                        label={"Включен пробег (км)"}
                      />
                    </Box>
                  </Flex>
                  {/* <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <SimpleGrid
                    minChildWidth="120px"
                    spacing="40px"
                    marginTop={"20px"}
                    marginBottom={"20px"}
                  >
                    <Field
                      name={"promo_points"}
                      component={CustomInput}
                      placeholder={"Начислено баллов за поездку"}
                      label={"Начислено баллов за поездку"}
                    />
                  </SimpleGrid> */}
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <Box width="50%">
                    {/* <Field
                      name="agreement_link"
                      component={({ input: { value, onChange, ...input } }) => {
                        console.log("agreement_link input", input, value);
                        return (
                          <div>
                            <input
                              {...input}
                              type="file"
                              onChange={({ target }) => {
                                console.log('onchange', target);
                                onChange(target.files)
                              }}
                            />
                            <p>{value[0]?.path}</p>
                          </div>
                        );
                      }}
                    /> */}
                    <DonwloadComponent
                      label="Договор аренды"
                      name="agreement_link"
                      // srcPic={destructure(name, values)}
                      url={process.env.REACT_APP_API_URL}
                      // onClick={() => {
                      //   handleLink(name, values);
                      // }}
                      // disabled={isDisabled(name, values)}
                    />
                    {values?.agreement_link && (
                      <div>
                        <p>
                          Загруженный файл:{" "}
                          {values?.agreement_link[0]?.path ||
                            values?.agreement_link}
                        </p>
                        {!Array.isArray(values?.agreement_link) && (
                          <a
                            target="_blank"
                            href={`${process.env.REACT_APP_API_URL}/${values?.agreement_link}`}
                          >
                            Скачать
                          </a>
                        )}
                      </div>
                    )}
                  </Box>
                  <Divider marginTop={"20px"} marginBottom={"20px"} />
                  <Button onClick={handleSubmit}>Сохранить</Button>
                </Box>
              </Flex>
            </Container>
          </Box>
        );
      }}
    />
  );
};
